import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // URL 파라미터를 가져오기 위한 useParams Hook
import ReactMarkdown from 'react-markdown';
import './markdown.css'

function PostDetail() {
    const { id } = useParams(); // URL에서 'id' 파라미터를 가져옵니다. (예: /posts/1 에서 1)
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPost = async () => {
            try {
                setLoading(true);
                setError(null);
                // 가상의 API 호출 (실제로는 id를 사용하여 해당 게시물 데이터를 가져옴)
                const response = await fetch(`https://api.plaaa.at/blog/${id}.md`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.text();
                setPost(data);
            } catch (err) {
                console.error("게시물 상세 데이터를 가져오는 중 오류 발생:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPost();
    }, [id]); // id가 변경될 때마다 이펙트를 다시 실행하여 새로운 게시물 로드

    if (loading) return <p style={{ textAlign: 'center' }}>게시물 로딩 중...</p>;
    if (error) return <p style={{ textAlign: 'center', color: 'red' }}>게시물 로드 오류: {error}</p>;
    if (!post) return <p style={{ textAlign: 'center' }}>게시물을 찾을 수 없습니다.</p>;

    return (
        <div className="markdown-content mx-auto px-4 py-8 font-nanum-gothic">
            <ReactMarkdown>{ post }</ReactMarkdown>
        </div>
    );
}

export default PostDetail;